<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
    [nzVisible]="isVisibleProgramPeriodDrawer" [nzTitle]="programPeriodDrawerTitle" [nzFooter]="footerTpl"
    (nzOnClose)="handleCancel()">
    <ng-container *nzDrawerContent>
        <form nz-form [formGroup]="_fS.programPeriodForm">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="programLabelError">
                            <label class="label-text required">Program label</label>
                            <input class="input-group" nz-input formControlName="labelName" minlength="2" maxlength="100" />
                            <ng-template #programLabelError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter program label
                                </ng-container>
                                <ng-container *ngIf="control.hasError('minlength')">Program label {{validationMessage.minlength}}
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="startMonthError">
                            <label class="label-text required">Program start</label>
                            <nz-select #proStartMonth nzShowSearch nzPlaceHolder="Month" [nzSize]="'default'"
                                formControlName="programStartMonth" [nzSelectOnTab]="true" (ngModelChange)="focusProStartYear($event)">
                                <nz-option *ngFor="let option of listOfMonths" [nzLabel]="option" [nzValue]="option">
                                </nz-option>
                            </nz-select>
                            <ng-template #startMonthError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select program start month
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>


                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item class="pt-27">
                        <nz-form-control [nzErrorTip]="startYearError">
                            <nz-select #proStartYear nzShowSearch nzPlaceHolder="Year" [nzSize]="'default'"
                                formControlName="programStartYear" [nzSelectOnTab]="true"
                                (ngModelChange)="onSelectStartYear($event)">
                                <nz-option *ngFor="let option of listOfYears" [nzLabel]="option" [nzValue]="option">
                                </nz-option>
                            </nz-select>
                            <ng-template #startYearError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select program start year
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="endMonthError">
                            <label class="label-text required">Program end</label>
                            <nz-select #proEndMonth nzShowSearch nzPlaceHolder="Month" [nzSize]="'default'"
                                formControlName="programEndMonth" [nzSelectOnTab]="true" (ngModelChange)="focusProEndYear($event)">
                                <nz-option *ngFor="let option of listOfMonths" [nzLabel]="option" [nzValue]="option">
                                </nz-option>
                            </nz-select>
                            <ng-template #endMonthError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select program end month
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item class="pt-27">
                        <nz-form-control [nzErrorTip]="endYearError">
                            <nz-select  #proEndYear nzShowSearch nzPlaceHolder="Year" [nzSize]="'default'"
                                formControlName="programEndYear" [nzSelectOnTab]="true">
                                <nz-option *ngFor="let option of listOfEndYears" [nzLabel]="option" [nzValue]="option">
                                </nz-option>
                            </nz-select>
                            <ng-template #endYearError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select program end year
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item class="margin-none">
                        <nz-form-control class="switch-box">
                            <nz-switch formControlName="isProgramPeriodActive" ></nz-switch>
                            <label class="switch-label black mr-1">{{
                                _fS.programPeriodForm.get("isProgramPeriodActive").value ? "Visible" : "Hidden"
                                }}</label>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
        </form>
    </ng-container>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end">

            <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingOne"
                class="medium-btn small-btn width-100 mr-1">{{selectedProgramPeriodData != null ? 'Update' :
                'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()"
                class="default-btn width-100">Cancel</button>


        </div>
    </ng-template>
</nz-drawer>